import {Race, RaceStartItem} from "@model";

export interface SaveOrUpdateRaceStartResponse {
    race?: Race | undefined;
    startItem?: RaceStartItem | undefined;
    statusCode?: StatusCode | undefined;
}

export enum StatusCode {
    CHECKPOINT_DATA_EXIST = 'CHECKPOINT_DATA_EXIST',
    OK = 'OK'
}
